import { Optional } from 'common/models/optional';
import React from 'react';
import { NumberUtils } from 'utils/numberUtils';
import FormatNumber from '../FormatPercent/FormatNumber';

type Props = {
  display: boolean;
  redeemFee: Optional<number>;
  toCollect: Optional<bigint>;
  isLoading: boolean;
  collateralName: string;
};

const RedeemMetadata: React.FC<Props> = (props) => {
  if (!props.display) {
    return null;
  }

  return (
    <div className="content-inner-bg-color p-3 m-3">
      <div className="flex flex-row justify-between">
        <div className="heading-color">Redemption Fee</div>
        <FormatNumber
          value={props.redeemFee ? props.redeemFee * 100 : 0}
          postfix="%"
          isLoading={props.isLoading}
          className="primary-text-color font-medium"
        />
      </div>
      <div className="flex flex-row justify-between">
        <div className="heading-color">You Receive</div>
        <FormatNumber
          value={
            props.toCollect
              ? NumberUtils.BNtoNumberWithoutDecimals(
                  props.toCollect.toString(),
                  18
                )
              : 0
          }
          postfix={' ' + props.collateralName}
          displayDecimals={3}
          isLoading={props.isLoading}
          className="primary-text-color font-medium"
        />
      </div>
    </div>
  );
};

export default RedeemMetadata;
